import axios from 'axios';

const createApi = (initDataRaw) => {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL
    });

    instance.interceptors.request.use((config) => {
        const authData = initDataRaw || window.Telegram?.WebApp?.initData || window.Telegram?.WebApp?.initDataUnsafe;

        if (authData) {
            config.headers['Telegram-Init-Data'] = authData;
        }
        return config;
    });

    return instance;
};

// API функции для трат
export const getExpensesToday = (api) => api.get('/api/expenses/today');
export const getExpensesMonthly = (api, month, year) => api.get('/api/expenses/monthly', { params: { month, year } });
export const getExpensesAll = (api, month, year, category) => api.get('/api/expenses/all', { params: { month, year, category } });
export const getFrequentCategories = (api) => api.get('/api/expenses/frequent-categories');
export const createExpense = (api, data) => api.post('/api/expenses', data);
export const updateExpense = (api, id, data) => api.patch(`/api/expenses/${id}`, data);
export const deleteExpense = (api, id) => api.delete(`/api/expenses/${id}`);

// API функции для баланса и категорий
export const getBalance = (api) => api.get('/api/balance');
export const getAllowedCategories = (api) => api.get('/api/categories/allowed');

// API функции для целей
export const getGoals = (api) => api.get('/api/goals');
export const createGoal = (api, data) => api.post('/api/goals', data);
export const deleteGoal = (api, id) => api.delete(`/api/goals/${id}`);
export const contributeToGoal = (api, id, amount) => api.post(`/api/goals/${id}/contribute`, { amount });
export const getGoalContributions = (api, id) => api.get(`/api/goals/${id}/contributions`);

// API функции для бюджетов
export const getBudgets = (api, month, year) => api.get('/api/budgets', { params: { month, year } });
export const createBudget = (api, data) => api.post('/api/budgets', data);
export const updateBudget = (api, id, data) => api.patch(`/api/budgets/${id}`, data);
export const deleteBudget = (api, id) => api.delete(`/api/budgets/${id}`);
export const redistributeBudget = (api, data) => api.post('/api/budgets/redistribute', data);

// API функции для счетов
export const getAccounts = (api) => api.get('/api/accounts');
export const createAccount = (api, data) => api.post('/api/accounts', data);
export const updateAccount = (api, id, data) => api.patch(`/api/accounts/${id}`, data);
export const deleteAccount = (api, id) => api.delete(`/api/accounts/${id}`);
export const transferBetweenAccounts = (api, data) => api.post('/api/accounts/transfer', data);
export const reconcileAccount = (api, id, data) => api.post(`/api/accounts/${id}/reconcile`, data);
export const getAccountTransfers = (api) => api.get('/api/accounts/transfers');

export default createApi;